import React from "react";
import "../styles/about.css";

const About = () => {
  return (
    <div>
      <p>
        I’m Manasa R, a passionate <strong>Full Stack Developer</strong> from{" "}
        <strong>Bengaluru, India</strong>. I love crafting user-friendly, high-performance 
        web applications that blend clean design with robust engineering.
      </p>

      <p>
        I hold a <strong>Bachelor’s degree in Electronics and Communication Engineering</strong>  
         from <strong>Jawaharlal Nehru National College of Engineering, Shivamogga</strong>. 
        To further specialize, I completed a <strong>Full Stack Development</strong> course 
        with <strong>UpGrad</strong>, gaining expertise in the <strong>MERN stack</strong>.
      </p>

      <p>
        I worked as a <strong>Full Stack Developer at Glider AI</strong>, where I built 
        scalable applications using <strong>React.js, Node.js, and MongoDB</strong>. I 
        contributed to optimizing hiring processes by developing <strong>candidate reports 
        from chatbot interactions</strong> and implementing <strong>custom question types</strong> 
        to enhance recruitment efficiency.
      </p>

      <p>
        I am <strong>dedicated and dependable</strong>, with a strong focus on problem-solving 
        and attention to detail. I take a <strong>thorough approach</strong> to learning and 
        implementation, ensuring that I understand concepts deeply before applying them. My 
        collaborative mindset and adaptability help me thrive in team environments.
      </p>
    </div>
  );
};

export default About;
